<template>
    <v-app id="manuals">
        <v-content>
            <v-app-bar app
                       dark
                       color="white">
                <v-toolbar-title>
                    <v-img src="/images/logo.png"
                           height="40"
                           contain>
                    </v-img>
                </v-toolbar-title>
            </v-app-bar>
            <v-container fluid>
                <router-view>
                </router-view>
            </v-container>
        </v-content>
    </v-app>
</template>
<script>
    export default {}
</script>
